export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-blind-4390363e14da0964dbf5e6dad85f8a80.svg";